<template>
  <el-dialog
    top="15vh"
    class="series-edit__dialog"
    :title="row.id ? $t('Common.edit') : $t('Common.create')"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('Product.productCategory')" prop="category">
        <Select
          :query="$api.common.product_type_select"
          v-model="form.category"
          :placeholder="$t('Product.productCategory')"
        >
        </Select>
      </el-form-item>
      <el-form-item :label="$t('Product.serialName')" prop="name">
        <el-input
          v-model="form.name"
          :placeholder="$t('Common.maxLengthTips16')"
          :maxlength="16"
          @blur="setLangLocal"
        >
        </el-input>
        <hl-button type="text" @click="setLang" style="margin-left: 8px">
          {{ $t('Common.setLang') }}</hl-button
        >
      </el-form-item>
      <el-form-item :label="$t('Product.serialCode')" prop="code">
        <el-input v-model="form.code" :placeholder="$t('Product.serialCode')"> </el-input>
      </el-form-item>
      <el-form-item :label="$t('Common.remark')" prop="remarks">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.remarks"
          :placeholder="$t('Common.remark')"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
    <SetLang
      :row="langRow"
      v-if="visibleLang"
      @saveLang="saveLang"
      :visible.sync="visibleLang"
    ></SetLang>
  </el-dialog>
</template>

<script>
import SetLang from './components/SetLang'
import Select from '@/components/CommonForm/Select'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    Select,
    SetLang
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      form: {
        nameContentObj: {},
        nameContent: [],
        category: ''
      },
      rules: {
        category: [
          { required: true, message: this.$t('Product.productCategory'), trigger: 'change' }
        ],
        name: [{ required: true, message: this.$t('Product.serialName'), trigger: 'blur' }],
        code: [{ required: true, message: this.$t('Product.serialCode'), trigger: 'blur' }]
      },
      loading: false,
      visibleLang: false,
      langRow: []
    }
  },
  created() {
    if (this.row.id) {
      let params = {
        id: this.row.id
      }
      this.$ajax
        .get(this.$api.product.series_detail, params)
        .then((res) => {
          this.form = {
            ...res.data,
            nameContent: res.data.nameContent ? JSON.parse(res.data.nameContent) : []
          }
        })
        .catch(() => {})
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },

    saveLang(nameObj) {
      this.$set(this.form, 'nameContent', nameObj.nameContent)
      this.$set(this.form, 'nameContentObj', nameObj.nameContentObj)
      // this.$set(this.form, 'name', nameObj.nameContentObj[this.locale])
    },
    setLangLocal() {
      this.$set(this.form.nameContentObj, this.locale, this.form.name)
    },
    setLang() {
      // let arr = []
      // if (this.form.nameContent.length > 0) {
      //   arr = JSON.parse(JSON.stringify(this.form.nameContent))
      // } else {
      //   let nameContentKeys = Object.keys(this.form.nameContentObj)
      //   nameContentKeys.forEach((item) => {
      //     let newObj = {}
      //     newObj['language'] = item
      //     newObj['name'] = this.form.nameContentObj[item]
      //     arr.push(newObj)
      //   })

      let arr = []
      if (this.form.nameContent.length > 0) {
        arr = JSON.parse(JSON.stringify(this.form.nameContent))
      } else {
        arr.push({})
        // if (this.form.nameContentObj) {
        //   let nameContentKeys = Object.keys(this.form.nameContentObj)
        //   nameContentKeys.forEach((item) => {
        //     let newObj = {}
        //     newObj['language'] = item
        //     newObj['name'] = this.form.nameContentObj[item]
        //     arr.push(newObj)
        //   })
        // } else {
        //  let newObj = {}
        //   newObj['language'] = this.locale
        //   newObj['name'] = this.form.name
        //   arr.push(newObj)
        // }
      }

      this.langRow = arr
      this.visibleLang = true
    },

    save() {
      if (!this.checkForm()) return
      this.loading = true
      let params = {
        nameContent: JSON.stringify(this.form.nameContent),
        id: this.row.id,
        category: this.form.category,
        name: this.form.name,
        code: this.form.code,
        remarks: this.form.remarks
      }
      let api = this.row.id ? this.$api.product.series_update : this.$api.product.series_add
      this.$ajax
        .post(api, params)
        .then(() => {
          this.$message.success(
            `${this.row.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`
          )
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.series-edit__dialog {
  /deep/.el-dialog__body {
    padding-left: 40px;
  }
}
</style>
